import { InjectionToken, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { TraceService } from '@sentry/angular';
import { ENV_NAME, ENV_PROD_BUILD, ENV_RELEASE_VERSION } from '@y42/environment';
import { FullStoryService } from '../full-story/full-story.service';
import { SentryService } from './sentry.service';

export const ENABLE_SENTRY = new InjectionToken<boolean>('Enable Sentry SDK');

export function sentryServiceFactory(
  enableSentry: boolean,
  fullStory: FullStoryService,
  production: boolean,
  environmentName: string,
  releaseVersion: string,
) {
  if (enableSentry) {
    return new SentryService(fullStory, production, environmentName, releaseVersion);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const noop: any = () => undefined;
  const noopSentryService = {
    setUser: noop,
    clearUser: noop,
    captureException: noop,
    captureMessage: noop,
    setTag: noop,
  } as SentryService;
  return noopSentryService;
}

@NgModule({
  providers: [
    {
      provide: SentryService,
      useFactory: sentryServiceFactory,
      deps: [ENABLE_SENTRY, FullStoryService, ENV_PROD_BUILD, ENV_NAME, ENV_RELEASE_VERSION],
    },
    {
      provide: TraceService,
      deps: [Router],
    },
  ],
})
export class SentryModule {
  constructor(readonly sentry: SentryService, readonly trace: TraceService) {}
}
